import { NgModule } from '@angular/core';
import { CmTooltipLabelDirective } from './directives/cm-tooltip-label.directive';

const declarations = [CmTooltipLabelDirective];

@NgModule({
	declarations,
	exports: [...declarations],
})
export class AccessibilityModule {}
